
import React from 'react';
import uRLs from '../../../utils/baseUtils';
import DateConverter from "@heartinz/date_and_time_processor";
import { capitalizeFirstLetter } from '../../../utils/helper';
import { useEscapeKeyContext } from '../../../contexts/UseEscapKeyContext';
import { CircularProgress } from "@mui/material";

function ViewKYC({ onClose = () => { }, isData,onApprove,loading }) {  
    const kyc = isData || {}; 
     const {useEscapeKey}=useEscapeKeyContext();
     useEscapeKey(onClose)
     return (
        <div>
            <div className="modal-backdrop show"></div>
            <div
                className="modal show d-block"
                id="KYCModal"
                tabIndex="0"
                aria-modal="true"
                role="dialog"
            >                
                <div className="modal-dialog modal-dialog-centered modal-xl">
                    <div className="modal-content">
                        
                                          <div className="modal-header border-bottom-0 py-3">
                            <h6 className="modal-title">KYC Review: {kyc.fullName}</h6>                           
                             <button
                                type="button"
                                className="btn-close border"
                                onClick={onClose}
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                ></button>
                        </div>
                        
                        <div className="modal-body p-4">
                            
                  
                            <div className="d-flex justify-content-end align-items-center mb-4 pb-2 border-bottom">
                                {/* <h6 className="mb-0 text-muted">Request ID: <strong className="text-dark">{kyc.id}</strong></h6> */}
                                <div>
                                     {kyc.status === "SUBMITTED" ? (
                                        loading.update === kyc.partnerId ?  (
                                                                    <button
                                                                        className="btn btn-primary pb-0 text-right"
                                                                         disabled >                                        
                                                                        <CircularProgress size={22} className="text-white" />
                                                                    </button>                                                        
                                                                  ) : ( 
                                            <button
                                            className="btn btn-primary fs-6 py-2 px-3"
                                            onClick={() => onApprove(kyc.partnerId)}
                                            >
                                            Approve
                                            </button>
                                        )) : (
                                    <span 
                                        className={`badge fs-6 py-2 px-3 ${                                           
                                            kyc.status === 'APPROVED' ? ' bg-label-spring fw-bold' :
                                            kyc.status === 'PENDING' ? 'bg-secondary fw-bold' :
                                            'bg-secondary'
                                        }`}
                                    >
                                            {kyc.status === 'APPROVED'
                                            ? 'Approved'
                                            : kyc.status === 'PENDING'
                                            ? 'Draft'
                                            : kyc.status || "No Status"}

                                    </span>
                                   )}
                                  </div>
                            </div>                        
                            <div className="row">                               

                                <div className="col-lg-12 border-end">
                                    <h5 className="mb-3 text-primary">👤 User Data & Financials</h5>
                                    
                                   
                                    <div className="row g-3">
                                        <div className="col-sm-6">
                                            <label className="form-label text-muted">Full Name</label>
                                            <p className="fw-bold mb-0">{capitalizeFirstLetter(kyc?.fullName)}</p>
                                        </div>
                                        <div className="col-sm-6">
                                            <label className="form-label text-muted">Mobile Number</label>
                                            <p className="fw-bold mb-0">{kyc?.mobileNumber ||"-"}</p>
                                        </div>
                                        <div className="col-sm-12">
                                            <label className="form-label text-muted">Aadhaar Number</label>
                                            <p className="fw-bold mb-0">{kyc?.aadharNumber ? kyc.aadharNumber.replace(/(\d{4})(?=\d)/g, '$1 ') : ''}</p>
                                        </div>
                                        
                                        <div className="col-12"><hr className="my-2" /></div>

                                        <div className="col-sm-6">
                                            <label className="form-label text-muted">Beneficiary / Account Holder Name</label>
                                            <p className="fw-bold mb-0">{capitalizeFirstLetter(kyc?.bankDetails?.beneficiaryName)||"-"}</p>
                                        </div>
                                        <div className="col-sm-6">
                                            <label className="form-label text-muted">IFSC Code</label>
                                            <p className="fw-bold mb-0">{kyc?.bankDetails?.IFSC ||"-"}</p>
                                        </div>
                                        <div className="col-sm-6">
                                            <label className="form-label text-muted">Account Number</label>
                                            <p className="fw-bold mb-0 text-blue">{kyc?.bankDetails?.accountNumber ||"-"}</p>
                                        </div>
                                        <div className="col-sm-6">
                                            <label className="form-label text-muted">UPI ID</label>
                                            <p className="fw-bold mb-0">{kyc.upiId ||"-"}</p>
                                        </div>
                                    </div>

                                    <h5 className="mt-4 mb-3 text-primary">🕒 Date & Time</h5>
                                    <p className='ms-4'><small>  { DateConverter.ISOToDisplayFormat(
                                                              DateConverter.convertToTimeZone(kyc?.createdAt, uRLs.TIMEZONE)
                                                            ).date}</small><small className='ms-2'>  { DateConverter.ISOToDisplayFormat(
                                                              DateConverter.convertToTimeZone(kyc?.createdAt, uRLs.TIMEZONE)
                                                            ).time}</small></p>                                   

                                </div>                               
                                                        
                            </div>
                            
                        </div>
                        
                        <div className="modal-footer d-flex justify-content-end">
                            <button type="button" className="btn btn-outline-secondary" onClick={onClose} >
                               <i class="bx bx-x"></i>  Close
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}

export default ViewKYC;